// Function to initialize tabs within a specific container
function initializeTabsForContainer(container) {
  // Get all the tabs and panes within the specified container
  var navTabs = container.querySelectorAll(".nav-tabs li");
  var tabPanes = container.querySelectorAll(".tab-pane");

  // Function to remove 'active' classes from tabs and panes
  function deactivateAllTabs() {
    navTabs.forEach(function (tab) {
      tab.classList.remove("active");
    });
    tabPanes.forEach(function (pane) {
      pane.classList.remove("active");
    });
  }

  // Function to activate a tab
  function activateTab(tab, paneId) {
    deactivateAllTabs();
    tab.classList.add("active");
    container.querySelector(paneId).classList.add("active");
  }

  // Add click event listeners to each tab
  navTabs.forEach(function (tab) {
    var anchor = tab.querySelector("a");
    var paneId = anchor.getAttribute("href");

    anchor.addEventListener("click", function (event) {
      // Prevent the anchor link from changing the URL hash
      event.preventDefault();

      // Activate the clicked tab
      activateTab(tab, paneId);
    });
  });
}

// DOMContentLoaded event to ensure the HTML is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Select all tab containers on the page and initialize them
  var tabContainers = document.querySelectorAll(".container--tabs");

  tabContainers.forEach(function (container) {
    initializeTabsForContainer(container);
  });
});
